import { memo } from "react"

import './index.scss'
import { isValidUrl } from "../../../../services/utils/validation"

type FileColumn = {
  value: string
  url: string
}

const FileColumn = memo(({ value, url }: FileColumn) => {
  const isValid = isValidUrl(url)

  if (!isValid) return value
  return (
    <div className="FileColumn">
      <a href={url} download={value} target="_blank">{value}</a>
    </div>
  )
})

export default FileColumn
